import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'

export default class ChatTopics extends Component {
  render() {
    let { userRequests, onSelect } = this.props
    let visibleRequests = userRequests && userRequests.filter(ur => !ur.hidden)
    return (
      <ul className="chat-topics chat-body-scrollbox list-unstyled">
      {
        visibleRequests == null || visibleRequests.length == 0 ?
          <li className="chat-no-messages">You have no open requests at this time.</li> :
          visibleRequests.map(request =>
            <li key={request.id}>
              <ChatTopic userRequest={request} onSelect={onSelect} />
            </li>
          )
      }
      </ul>
    )
  }
}

function ChatTopic({ userRequest, onSelect }) {
  let classes = classNames("chat-topic btn", { closed: userRequest.status == 'processed' })
  return (
    <a className={classes} href='#' onClick={e => { e.preventDefault(); onSelect(userRequest) }}>
      <span className="chat-topic-title">{userRequest.displayName}</span>
      <i className="chat-topic-chevron">
        <FontAwesomeIcon icon={faChevronRight} />
      </i>
    </a>
  )
}
